var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueRing752(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 180,
    viewBox: "0 0 187 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 14",
    opacity: 0.6,
    filter: "url(#filter0_f_153_411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.886 63.1837C134.537 70.3402 136.962 78.7152 136.854 87.2498C136.745 95.7844 134.109 104.095 129.277 111.131C124.445 118.167 117.636 123.613 109.709 126.779C101.783 129.945 93.0956 130.689 84.7462 128.918C76.3967 127.146 68.76 122.939 62.8017 116.827C56.8435 110.716 52.8313 102.975 51.2725 94.5832C49.7138 86.1914 50.6785 77.5259 54.0446 69.6824C57.4108 61.839 63.0272 55.1698 70.1837 50.5183L77.2391 61.3734C72.2296 64.6295 68.2981 69.2979 65.9418 74.7883C63.5855 80.2787 62.9102 86.3446 64.0014 92.2188C65.0925 98.093 67.901 103.512 72.0718 107.79C76.2426 112.068 81.5883 115.013 87.4329 116.253C93.2775 117.493 99.3586 116.972 104.907 114.756C110.456 112.539 115.222 108.728 118.604 103.802C121.987 98.8773 123.832 93.0597 123.908 87.0855C123.984 81.1113 122.287 75.2487 119.031 70.2392L129.886 63.1837Z",
    fill: "#68C9FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_153_411",
    x: 0.546753,
    y: 0.518311,
    width: 186.31,
    height: 179.339,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "effect1_foregroundBlur_153_411"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueRing752);
export default __webpack_public_path__ + "static/media/blue-ring75-2.15e75dd8cfddbad9347ea9044d6938e8.svg";
export { ForwardRef as ReactComponent };